import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@driftt/tide-core'
import { installAppToDrift } from 'api/developerApi'
import './style.css'

class AppPreInstallView extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    setToken: PropTypes.func.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isInstalling: false,
    isInstalled: false
  }

  onInstall = () => {
    const { appId, setToken } = this.props

    const onDone = (token) => {
      const onStateSet = () => setToken(token)
      this.setState({ isInstalled: true, isInstalling: false }, onStateSet)
    }
    const onError = (error) => {
      this.props.showErrorNotification('We couldn’t install your app. Please try again.')
      this.setState({ isInstalling: false })
    }

    const onStateSet = () => installAppToDrift(appId)
      .then(onDone)
      .catch(onError)

    this.setState({ isInstalling: true }, onStateSet)
  }

  render() {
    const { isInstalling, isInstalled } = this.state

    return (
      <div className="app-install-view">
        <span className="page-title">
          Install App
        </span>
        <p className="page-description">
          Install your app to your Drift organization to test your app and generate the tokens you need to interact with the Drift API.
        </p>
        <Button
          type="primary"
          size="medium"
          disabled={isInstalled}
          className="app-install-view-button"
          onClick={this.onInstall}
          loading={isInstalling}>
          Install App to Drift
        </Button>
      </div>
    )
  }
}

export default AppPreInstallView
